
const yayinlamaSecenekleriOptions = [
    {
        id:1,
        text: "Herkese Yayınla",
    },
    {
        id:2,
        text: "Önce Yük Arayan Araçlarıma - Sonra Herkese Yayınla",
    },
    {
        id:3,
        text: "Yük Arayan Araçlarıma Yayınla",
    },
    {
        id:4,
        text: "İş Listemde Kalsın",
    }
]

export default yayinlamaSecenekleriOptions